import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Grid,
  Paper,
  Tooltip,
  IconButton,
  Menu,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  Search as SearchIcon,
  Visibility as ViewIcon,
  Edit as EditIcon,
  CloudUpload as SyncIcon,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Table,
  Tooltip as Tooltip1,
  Button as Button1,
  Space,
  Spin,
  Popover,
  Checkbox,
  Empty,
} from "antd";
import {
  LockOutlined,
  EditOutlined,
  EyeOutlined,
  CloudUploadOutlined,
  HistoryOutlined,
  MoreOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import invoiceApi from "../api/invoiceApi";
import invoiceTemplateApi from "../api/invoiceTemplateApi";
import invoiceConfigApi from "../api/invoiceConfigApi";

import InvoiceModal from "./InvoiceModal";
import InvoiceHistoryModal from "./InvoiceHistoryModal";
import InformationDialog from "../components/InformationDialog";
import CustomToolbar from "../components/CustomToolbar";
import ConfirmDialog from "../components/ConfirmDialog";

const invoiceStatus = [
  { value: -1, label: "Tất cả" },
  { value: 1, label: "Phiếu chưa có thông tin" },
  { value: 2, label: "Chưa có mã CQT" },
  { value: 3, label: "Chưa ký số" },
  { value: 4, label: "Chưa đồng bộ CQT" },
  {
    value: 5,
    label:
      "Đã đồng bộ CQT (tất cả hđ đã đồng bộ, bao gồm chưa ký, đã ký và lỗi)",
  },
  { value: 6, label: "Đã đồng bộ, chưa ký" },
  { value: 7, label: "Đã đồng bộ, CQT trả lỗi" },
  { value: 8, label: "Đã đồng bộ, đã ký thành công" },
  { value: 9, label: "Lỗi đồng bộ CQT" },
  { value: 10, label: "Có điều chỉnh hoá đơn" },
  { value: 11, label: "Có thay thế hoá đơn" },
  { value: 12, label: "Có lập thông báo sai sót hoá đơn" },
];

const pageNo = "InvoicePage";
function InvoicePage() {
  const roles = useSelector((state) => state.auth.roles) || null;
  const customerInfor = useSelector((state) => state.auth.customerInfor);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [anchorElRow, setAnchorElRow] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);

  const [openInvoiceHistoryModal, setOpenInvoiceHistoryModal] = useState(false);

  // --- State cho các tham số truy vấn thực tế được gửi lên API (query states) ---
  const [searchQuery, setSearchQuery] = useState({
    cusId: customerInfor.CusId,
    invoiceTemplateId: -1,
    invoiceStatus: -1,
    fromDate: dayjs(),
    toDate: dayjs(),
    searchKeyword: "",
    fromAmount: null,
    toAmount: null,
    isNormal: true,
    paymentMethod: "-1",
  });

  // --- State cho dữ liệu DataGrid và phân trang ---
  const [invoices, setInvoices] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 20,
  });
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [loadingHoaDon, setLoadingHoaDon] = useState(false);

  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [editingInvoiceData, setEditingInvoiceData] = useState(null);

  const [invoiceTemplate, setInvoiceTemplate] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([
    { value: "-1", label: "Tất cả" },
  ]);
  const [isSystemProcessing, setIsSystemProcessing] = useState(false);

  const [informationDialogState, setInformationDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    confirmText: "Xác nhận",
  });
  const [invoiceConfig, setInvoiceConfig] = useState(null);
  const [totalInvoiceTmp, setTotalInvoiceTmp] = useState(0);
  const [totalInvoiceSync, setTotalInvoiceSync] = useState(0);
  const [totalInvoiceSign, setTotalInvoiceSign] = useState(0);
  const [totalInvoiceRemain, setTotalInvoiceRemain] = useState(0);

  const [summary, setSummary] = useState({
    TotalItemAmount: 0,
    TotalDiscountAmount: 0,
    TotalBeforeTax: 0,
    TotalVatAmount: 0,
    TotalAfterTax: 0,
  });

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });
  const [openGuestModal, setOpenGuestModal] = useState(false);
  const [guestNameExport, setGuestNameExport] = useState(
    "Người mua không cung cấp thông tin",
  );
  const [isExporting, setIsExporting] = useState(false);

  const handleOpenRowMenu = (event, row) => {
    setAnchorElRow(event.currentTarget);
    setCurrentRow(row);
  };

  const handleCloseRowMenu = () => {
    setAnchorElRow(null);
    setCurrentRow(null);
  };

  // --- Hàm để tải danh sách chi nhánh từ API ---
  useEffect(() => {
    async function fetchInvoiceTemplate() {
      try {
        const response = await invoiceTemplateApi.searchTemplates(
          customerInfor.CusId,
          "",
          0,
          100,
        );
        if (response.success) {
          setInvoiceTemplate((prev) => [
            { value: -1, label: "Tất cả" },
            ...response.data.result.map((x) => ({
              value: x.ItId,
              label: x.ItIsActive ? (
                x.signName
              ) : (
                <s style={{ textDecorationColor: "red" }}>
                  {x.signName + "(ngưng)"}
                </s>
              ),
            })),
          ]);
        } else {
          setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
          console.error("Error fetchInvoiceTemplate: " + response.message);
        }
      } catch (error) {
        setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
        console.error("Error fetchInvoiceTemplate: " + error.message);
      } finally {
      }
    }

    async function fetchPaymentMethod() {
      try {
        const response = await invoiceApi.GetAllPaymentMethod(
          customerInfor.CusId,
        );
        if (response.success) {
          setPaymentMethods(() => [
            { value: "-1", label: "Tất cả" },
            ...response.data.map((x) => ({
              value: x.PaymentMethod,
              label: x.PaymentMethod,
            })),
          ]);
        } else {
          setPaymentMethods([{ value: "-1", label: "Tất cả" }]);
          toast.error(response.message);
        }
      } catch (error) {
        setPaymentMethods([{ value: "-1", label: "Tất cả" }]);
        toast.error(error);
      } finally {
      }
    }
    async function fetchInvoiceConfig() {
      try {
        const response = await invoiceConfigApi.GetInvoiceConfig(
          customerInfor.CusId,
        );
        if (response.success) {
          setInvoiceConfig(response.data);
          setGuestNameExport(
            response.data.icBuyerDefaultName ||
              "Người mua không cung cấp thông tin",
          );
        } else toast.error(response.message);
      } catch (error) {
        toast.error(error);
      } finally {
      }
    }
    fetchInvoiceTemplate();
    fetchPaymentMethod();
    fetchInvoiceConfig();
  }, []);

  // --- Hàm để tải danh sách hóa đơn từ API ---
  const SearchInvoices = useCallback(async (query, pagination) => {
    setLoadingHoaDon(true);
    try {
      const response = await invoiceApi.searchInvoices(
        query.cusId,
        query.invoiceTemplateId === -1 ? null : query.invoiceTemplateId,
        query.searchKeyword,
        query.fromDate,
        query.toDate,
        pagination.page,
        pagination.pageSize,
        query.isNormal,
        query.invoiceStatus === -1 ? null : query.invoiceStatus,
        query.fromAmount,
        query.toAmount,
        query.paymentMethod === "-1" ? null : query.paymentMethod,
      );
      if (response.success) {
        const mappedData = response.data.Invoices.map((invoice) => ({
          ...invoice,
          id: invoice.ReiId,
          ReiDateStr: invoice.ReiDate
            ? dayjs(invoice.ReiDate).format("DD/MM/YYYY")
            : "",
        }));

        setInvoices(mappedData);
        setTotalRowCount(parseInt(response.pagination.totalRecords || 0, 10));
        setTotalInvoiceTmp(response.data.TotalInvoice.TotalInvoiceTmp);
        setTotalInvoiceSync(response.data.TotalInvoice.TotalInvoiceSync);
        setTotalInvoiceSign(response.data.TotalInvoice.TotalInvoiceSign);
        setTotalInvoiceRemain(response.data.TotalInvoice.TotalInvoiceRemain);
        setSummary(response.data.Summary);
      } else {
        console.error("API hóa đơn trả về dữ liệu không hợp lệ:", response);
        setInvoices([]);
        setTotalRowCount(0);
        setSummary({
          TotalItemAmount: 0,
          TotalDiscountAmount: 0,
          TotalBeforeTax: 0,
          TotalVatAmount: 0,
          TotalAfterTax: 0,
        });
      }
    } catch (error) {
      console.error("Lỗi khi tải danh sách hóa đơn:", error);
      setInvoices([]);
      setTotalRowCount(0);
      setSummary({
        TotalItemAmount: 0,
        TotalDiscountAmount: 0,
        TotalBeforeTax: 0,
        TotalVatAmount: 0,
        TotalAfterTax: 0,
      });
    } finally {
      setLoadingHoaDon(false);
      setRowSelectionModel([]);
    }
  }, []);

  const openInvoiceModalWithData = async (reiId, specialStatus = null) => {
    setLoadingHoaDon(true);
    try {
      const response = await invoiceApi.getInvoiceData(reiId);
      if (response.success && response.data) {
        let dataToEdit = { ...response.data };
        if (specialStatus !== null) {
          const tempResponse =
            await invoiceTemplateApi.GetInvoiceTemplateActive(dataToEdit.ReiId);
          const temp = tempResponse.data[0];

          if (specialStatus === 2) {
            dataToEdit = {
              ...dataToEdit,
              ReiId: null,
              ReiParentId: reiId,
              ReiStatus: specialStatus,
              ReiInvoiceNum: "",
              ReiEInvoiceId: "",
              ReiEInvoiceKey: null,
              ReiEStatus: 1,
              ReiLookupKey: "",
              ReiTaxAuthorityCode: "",
              ReiInvoiceNumParent: dataToEdit.ReiInvoiceNum,
              ReiEInvoiceIdParent: dataToEdit.ReiEInvoiceId,
              ReiDateParent: dataToEdit.ReiDate,
              ReiTaxAuthorityCodeParent: dataToEdit.ReiTaxAuthorityCode,
              ReiLookupKeyParent: dataToEdit.ReiLookupKey,
              ReiTemplateParent: dataToEdit.ReiTemplate,
              ReiSignParent: dataToEdit.ReiSign,
              ReiDate: dayjs(),
              ReiSign: temp.ItSign,
              ReiTemplate: temp.ItTemplate,
              ItId: temp.ItId,
            };
          } else {
            dataToEdit = {
              ...dataToEdit,
              ReiId: null,
              ReiParentId: reiId,
              ReiStatus: specialStatus,
              ReiInvoiceNum: "",
              ReiEInvoiceId: "",
              ReiEInvoiceKey: null,
              ReiEStatus: 1,
              ReiLookupKey: "",
              ReiTaxAuthorityCode: "",
              ReiItemAmount: 0,
              ReiDiscountAmount: 0,
              ReiAmountBeforeTax: 0,
              ReiVatAmount: 0,
              ReiAmountAfterTax: 0,
              ReiInvoiceNumParent: dataToEdit.ReiInvoiceNum,
              ReiEInvoiceIdParent: dataToEdit.ReiEInvoiceId,
              ReiDateParent: dataToEdit.ReiDate,
              ReiTaxAuthorityCodeParent: dataToEdit.ReiTaxAuthorityCode,
              ReiLookupKeyParent: dataToEdit.ReiLookupKey,
              ReiTemplateParent: dataToEdit.ReiTemplate,
              ReiSignParent: dataToEdit.ReiSign,
              Details: [],
              ReiDate: dayjs(),
              ReiSign: temp.ItSign,
              ReiTemplate: temp.ItTemplate,
              ItId: temp.ItId,
            };
          }
        }
        setEditingInvoiceData(dataToEdit);
        setIsInvoiceModalOpen(true);
      } else {
        toast.error(response.message || "Không tìm thấy thông tin hóa đơn.");
      }
    } catch (error) {
      console.error("Lỗi khi tải hóa đơn:", error);
      toast.error("Đã xảy ra lỗi khi tải thông tin hóa đơn.");
    } finally {
      setLoadingHoaDon(false);
    }
  };

  const handleClickAdjustInfo = async (event) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnAdjustInfor" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền tạo hoá đơn điều chỉnh thông tin.");
      return;
    }
    let row = currentRow;
    if (row.ReiStatus === 2) {
      toast.warning("Không thể điều chỉnh hoá đơn thay thế.");
      return;
    }
    if (!row.ReiInvoiceNum) {
      toast.warning("Hoá đơn chưa có số không thể điều chỉnh.");
      return;
    }
    if (row.ReiSource === 3) {
      toast.warning(
        "Hoá đơn này không được đồng bộ từ hệ thống THUEVAT.VN nên không thể tạo điều chỉnh.",
      );
      return;
    }
    const checkChild = await invoiceApi.CheckExistChild(row.ReiId, 3);
    if (checkChild.success) toast.error(checkChild.message);
    else {
      openInvoiceModalWithData(row.ReiId, 3);
    }
  };

  const handleClickAdjustIncrease = async (event) => {
    let row = currentRow;
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnAdjustIncrease" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền tạo hoá đơn điều chỉnh tăng.");
      return;
    }
    if (row.ReiStatus === 2) {
      toast.warning("Không thể điều chỉnh hoá đơn thay thế.");
      return;
    }
    if (!row.ReiInvoiceNum) {
      toast.warning("Hoá đơn chưa có số không thể điều chỉnh.");
      return;
    }
    if (row.ReiSource === 3) {
      toast.warning(
        "Hoá đơn này không được đồng bộ từ hệ thống THUEVAT.VN nên không thể tạo điều chỉnh.",
      );
      return;
    }
    const checkChild = await invoiceApi.CheckExistChild(row.ReiId, 4);
    if (checkChild.success) toast.error(checkChild.message);
    else {
      openInvoiceModalWithData(row.ReiId, 4);
    }
  };

  const handleClickAdjustDecrease = async (event) => {
    let row = currentRow;
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnAdjustDecrease" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền tạo hoá đơn điều chỉnh giảm.");
      return;
    }
    if (row.ReiStatus === 2) {
      toast.warning("Không thể điều chỉnh hoá đơn thay thế.");
      return;
    }
    if (!row.ReiInvoiceNum) {
      toast.warning("Hoá đơn chưa có số không thể điều chỉnh.");
      return;
    }
    if (row.ReiSource === 3) {
      toast.warning(
        "Hoá đơn này không được đồng bộ từ hệ thống THUEVAT.VN nên không thể tạo điều chỉnh.",
      );
      return;
    }
    const checkChild = await invoiceApi.CheckExistChild(row.ReiId, 5);
    if (checkChild.success) toast.error(checkChild.message);
    else {
      openInvoiceModalWithData(row.ReiId, 5);
    }
  };

  const handleClickReplaceInvoice = async (event) => {
    let row = currentRow;
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnReplaceInvoice" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền tạo hoá đơn thay thế.");
      return;
    }

    if (row.ReiStatus === 3 || row.ReiStatus === 4 || row.ReiStatus === 5) {
      toast.warning("Không thể thay thế hoá đơn điều chỉnh.");
      return;
    }
    if (!row.ReiInvoiceNum) {
      toast.warning("Hoá đơn chưa có số không thể thay thế.");
      return;
    }
    if (row.ReiSource === 3) {
      toast.warning(
        "Hoá đơn này không được đồng bộ từ hệ thống THUEVAT.VN nên không thể tạo thay thế.",
      );
      return;
    }
    const checkChild = await invoiceApi.CheckExistChild(row.ReiId, 2);
    if (checkChild.success) toast.error(checkChild.message);
    else {
      openInvoiceModalWithData(row.ReiId, 2);
    }
  };
  const handleClickGetLinkUpdateInvoice = async () => {
    let row = currentRow;
    try {
      const response = await invoiceApi.getLinkUpdateInvoice(row.ReiId);
      if (response.success) {
        window.open(response.data, "_blank");
      } else {
        toast.error(
          response.message || "Lỗi khi lấy link cập nhật thông tin hóa đơn.",
        );
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleCloseInvoiceModal = () => {
    setIsInvoiceModalOpen(false);
    setEditingInvoiceData(null);
    handleCloseRowMenu();
    SearchInvoices(searchQuery, paginationModel);
  };

  const handleSyncInvoice = async (ReiId, ReiEStatus, ReiSource) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnSyncInvoice" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền đồng bộ hoá đơn.");
      return;
    }
    if (ReiEStatus === 4) {
      toast.warning("Hóa đơn này đã ký không thể đồng bộ.");
      return;
    }
    if (ReiSource === 3) {
      toast.warning(
        "Hoá đơn này không được đồng bộ từ hệ thống THUEVAT.VN nên không thể đồng bộ lại.",
      );
      return;
    }
    try {
      setIsSystemProcessing(true);
      const response = await invoiceApi.syncInvoice(ReiId);
      if (response.success) {
        toast.success("Đồng bộ hóa đơn thành công!");
      } else {
        toast.error(response.message || "Lỗi khi đồng bộ hóa đơn.");
      }
    } catch (error) {
      console.error("Lỗi khi đồng bộ hóa đơn:", error);
      toast.error("Đã xảy ra lỗi khi đồng bộ hóa đơn: " + error.message);
    } finally {
      SearchInvoices(searchQuery, paginationModel);
      setIsSystemProcessing(false);
    }
  };

  useEffect(() => {
    SearchInvoices(searchQuery, paginationModel);
  }, [SearchInvoices]);

  const handleEditInvoice = (ReiId) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnEdit" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền sửa hoá đơn.");
      return;
    }
    openInvoiceModalWithData(ReiId);
  };

  const handleRemoveInvoice = async (status) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo && x.CtrNo === "btnDelete" && x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền xoá phiếu.");
      return;
    }
    if (rowSelectionModel.length <= 0) {
      toast.warning("Vui lòng chọn phiếu để xoá.");
      return;
    }
    if (status === 0) {
      setConfirmDialogState({
        open: true,
        title: "Xóa phiếu",
        content: "Bạn chắc chắn muốn xóa các phiếu này?",
        onConfirm: () => {
          handleRemoveInvoice(1);
          setConfirmDialogState({
            ...confirmDialogState,
            open: false,
          });
        },
        onClose: () =>
          setConfirmDialogState({
            ...confirmDialogState,
            open: false,
          }),
      });
      return;
    }
    try {
      const response = await invoiceApi.removeInvoice(rowSelectionModel);
      if (response.success) {
        toast.success("Xoá phiếu thành công!");
        SearchInvoices(searchQuery, paginationModel);
      } else {
        toast.error(response.message || "Lỗi khi xoá phiếu.");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleExportInvoiceGuest = async () => {
    if (!guestNameExport) {
      toast.warning("Vui lòng nhập tên người mua.");
      return;
    }
    setOpenBackdrop(true);
    try {
      const response = await invoiceApi.handleExportInvoiceGuest(
        guestNameExport,
        rowSelectionModel,
      );
      if (response.success) {
        toast.success("Thành công");
        setOpenGuestModal(false);
        setGuestNameExport(
          invoiceConfig?.icBuyerDefaultName ||
            "Người mua không cung cấp thông tin",
        );
        SearchInvoices(searchQuery, paginationModel);
      } else {
        toast.error(response.message || "Lỗi xử lý dữ liệu");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setOpenBackdrop(false);
    }
  };

  const handleGetInvoicesInfor = async () => {
    setIsSystemProcessing(true);
    try {
      const response = await invoiceApi.getInvoicesInfor(
        customerInfor.CusId,
        searchQuery.fromDate,
        searchQuery.toDate,
      );
      if (response.success) {
        toast.success("Đã lấy thông tin hóa đơn.");
        SearchInvoices(searchQuery, paginationModel);
      } else {
        toast.error(response.message || "Lỗi khi lấy thông tin hóa đơn.");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setIsSystemProcessing(false);
    }
  };
  const handleSyncInvoices = async (status) => {
    if (
      !roles.some(
        (x) =>
          x.PvNo === pageNo &&
          x.CtrNo === "btnSyncInvoice" &&
          x.IsApproved === true,
      )
    ) {
      toast.warning("Bạn không có quyền đồng bộ hoá đơn.");
      return;
    }
    if (rowSelectionModel.length <= 0) {
      toast.warning("Vui lòng chọn phiếu để đồng bộ.");
      return;
    }
    if (status === 0) {
      setConfirmDialogState({
        open: true,
        title: "Đồng bộ phiếu",
        content: "Bạn chắc chắn muốn đồng bộ các phiếu này?",
        onConfirm: () => {
          handleSyncInvoices(1);
          setConfirmDialogState({
            ...confirmDialogState,
            open: false,
          });
        },
        onClose: () =>
          setConfirmDialogState({
            ...confirmDialogState,
            open: false,
          }),
      });
      return;
    }
    setIsSystemProcessing(true);
    try {
      const response = await invoiceApi.syncInvoices(rowSelectionModel);
      if (response.success) {
        setInformationDialogState({
          open: true,
          title: "Thông báo",
          content: response.message || "Đồng bộ hóa đơn thành công.",
          onConfirm: () => {
            setInformationDialogState({
              ...informationDialogState,
              open: false,
            });
          },
          confirmText: "Xác nhận",
        });
      } else {
        setInformationDialogState({
          open: true,
          title: "Thông báo",
          content: response.message || "Đồng bộ hóa đơn thất bại.",
          onConfirm: () => {
            setInformationDialogState({
              ...informationDialogState,
              open: false,
            });
          },
          confirmText: "Xác nhận",
        });
      }
    } catch (error) {
      toast.error(error);
    } finally {
      SearchInvoices(searchQuery, paginationModel);
      setIsSystemProcessing(false);
    }
  };

  const handleSignInvoice = async () => {
    try {
      setIsSystemProcessing(true);
      if (rowSelectionModel.length <= 0) {
        toast.warning("Vui lòng chọn hóa đơn để ký.");
        return;
      }
      const response = await invoiceApi.signInvoice(rowSelectionModel);
      if (response.success) {
        toast.success(response.message || "Ký hóa đơn thành công.");
      } else {
        toast.error(response.message || "Lỗi khi ký hóa đơn.");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      SearchInvoices(searchQuery, paginationModel);
      setIsSystemProcessing(false);
    }
  };

  const btnGuest_Click = async () => {
    if (rowSelectionModel.length <= 0) {
      toast.warning("Vui lòng chọn phiếu.");
      return;
    }
    setOpenGuestModal(true);
  };

  const handleCloseGuestModal = () => {
    setOpenGuestModal(false);
    setGuestNameExport(
      invoiceConfig?.icBuyerDefaultName || "Người mua không cung cấp thông tin",
    );
  };

  const handleExportExcel = async () => {
    setIsExporting(true);
    try {
      const response = await invoiceApi.exportFilterInvoiceToExcel(
        searchQuery.cusId,
        searchQuery.invoiceTemplateId === -1
          ? null
          : searchQuery.invoiceTemplateId,
        searchQuery.searchKeyword,
        searchQuery.fromDate,
        searchQuery.toDate,
        searchQuery.isNormal,
        searchQuery.invoiceStatus === -1 ? null : searchQuery.invoiceStatus,
        searchQuery.fromAmount,
        searchQuery.toAmount,
        searchQuery.paymentMethod === "-1" ? null : searchQuery.paymentMethod,
      );
      const binaryData = response.data; // Lấy phần nội dung nhị phân

      if (
        !(binaryData instanceof Blob) &&
        !(binaryData instanceof ArrayBuffer)
      ) {
        toast.error("Lỗi xử lý dữ liệu!");
        console.error("Dữ liệu không phải nhị phân! Kiểm tra responseType.");
        return;
      }

      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Hóa đơn.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error);
    } finally {
      setIsExporting(false);
    }
  };
  // Cột cho DataGrid
  const allColumns = useMemo(() => {
    return [
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Trạng thái</div>
            <div>Ngày hóa đơn</div>
          </div>
        ),
        key: "ReiEStatusAndReiDate",
        width: 120,
        align: "center",
        label: "Trạng thái & Ngày HĐ",
        sorter: (a, b) => new Date(a.ReiDate) - new Date(b.ReiDate),
        render: (_, record) => (
          <div className="cell-column cell-center">
            <div>{record.ReiEStatusName}</div>
            <div>{record.ReiDateStr}</div>
          </div>
        ),
      },
      {
        title: "Số hoá đơn",
        dataIndex: "ReiInvoiceNum",
        key: "ReiInvoiceNum",
        align: "center",
        width: 100,
        label: "Số hoá đơn",
        sorter: (a, b) => {
          const strA = a.ReiInvoiceNum ?? "";
          const strB = b.ReiInvoiceNum ?? "";
          return strA.localeCompare(strB);
        },
      },
      {
        title: "Mã của CQT",
        dataIndex: "ReiTaxAuthorityCode",
        key: "ReiTaxAuthorityCode",
        align: "center",
        width: 130,
        label: "Mã CQT",
        sorter: true,
        sorter: (a, b) => {
          const strA = a.ReiTaxAuthorityCode ?? "";
          const strB = b.ReiTaxAuthorityCode ?? "";
          return strA.localeCompare(strB);
        },
        render: (text) => (
          <span
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              fontSize: "14px",
            }}
          >
            {text}
          </span>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Ký hiệu & Mẫu</div>
            <div>Chi nhánh</div>
          </div>
        ),
        key: "ReiSign_Template",
        width: 240,
        align: "center",
        label: "Ký hiệu, Mẫu & Chi nhánh",
        render: (_, record) => {
          const value1 = (record.ReiTemplate || "") + (record.ReiSign || "");
          const value2 = record.ItLocation;
          const content = (
            <div className="cell-column cell-center" style={{ width: "100%" }}>
              <div>{value1}</div>
              <div>{value2}</div>
            </div>
          );
          return (
            <Tooltip title={content} mouseenterdelay={0.4} placement="top">
              {content}
            </Tooltip>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tên người mua</div>
            <div>Mã số thuế</div>
          </div>
        ),
        key: "ReiBuyerName",
        width: 300,
        label: "Thông tin người mua",
        render: (_, record) => {
          const value1 = record.BuyerName;
          const value2 = record.ReiTaxId;
          const content = (
            <div className="cell-column">
              <div>{value1}</div>
              <div>{value2}</div>
            </div>
          );
          return (
            <Tooltip title={content} mouseenterdelay={0.4} placement="top">
              {content}
            </Tooltip>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Thành tiền</div>
            <div>Chiết khấu</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalItemAmount?.toLocaleString("vi-VN")}
            </div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalDiscountAmount?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        key: "ReiItemAmount_Discount",
        width: 120,
        align: "right",
        label: "Thành tiền & Chiết khấu",
        render: (_, record) => (
          <div className="cell-column">
            <div>{record.ReiItemAmount?.toLocaleString("vi-VN")}</div>
            <div>{record.ReiDiscountAmount?.toLocaleString("vi-VN")}</div>
          </div>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tiền trước thuế</div>
            <div>Tiền thuế</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalBeforeTax?.toLocaleString("vi-VN")}
            </div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalVatAmount?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        key: "ReiAmountBeforeTax",
        width: 120,
        align: "right",
        label: "Tiền trước thuế & Tiền thuế",
        render: (_, record) => (
          <div className="cell-column">
            <div>{record.ReiAmountBeforeTax?.toLocaleString("vi-VN")}</div>
            <div>{record.ReiVatAmount?.toLocaleString("vi-VN")}</div>
          </div>
        ),
      },
      {
        title: (
          <div style={{ textAlign: "center" }}>
            <div>Tổng cộng</div>
            <div style={{ textAlign: "center", color: "blue" }}>
              {summary.TotalAfterTax?.toLocaleString("vi-VN")}
            </div>
          </div>
        ),
        dataIndex: "ReiAmountAfterTax",
        key: "ReiAmountAfterTax",
        align: "right",
        width: 120,
        label: "Tổng cộng",
        sorter: (a, b) => a.ReiAmountAfterTax - b.ReiAmountAfterTax,
        render: (value) => (value != null ? value.toLocaleString("vi-VN") : ""),
      },
      {
        title: "Ghi chú",
        dataIndex: "ReiContent",
        key: "ReiContent",
        align: "center",
        width: 250,
        label: "Ghi chú",
      },
      {
        title: "Ghi chú phiếu",
        dataIndex: "ReiDescription",
        key: "ReiDescription",
        align: "center",
        width: 250,
        label: "Ghi chú phiếu",
      },
      {
        title: "Mã bill",
        dataIndex: "TkBillNo",
        key: "TkBillNo",
        align: "center",
        width: 150,
        label: "Mã bill",
      },
      {
        title: "Ngày đóng phiếu",
        dataIndex: "TkCloseDate",
        key: "TkCloseDate",
        align: "center",
        width: 150,
        label: "Ngày đóng phiếu",
        render: (value) => (value ? dayjs(value).format("DD/MM/YYYY") : ""),
      },
      {
        title: "Tờ HĐ",
        dataIndex: "StatusName",
        key: "StatusName",
        align: "center",
        width: 150,
      },
      {
        title: "Chức năng",
        key: "actions",
        width: 200,
        align: "center",
        fixed: "right", // 👑 CỐ ĐỊNH CỘT CHỨC NĂNG BÊN PHẢI
        render: (_, record) => (
          <Space size="small">
            {record.ReiIsApproved && (
              <Tooltip1 title="Phiếu này đang bị khoá sẽ không thể chỉnh sửa thông tin từ POS bán hàng.">
                <Button1
                  type="text"
                  shape="circle"
                  size="small"
                  icon={<LockOutlined />}
                />
              </Tooltip1>
            )}

            <Tooltip1 title="Sửa thông tin hóa đơn">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<EditOutlined />}
                onClick={() => handleEditInvoice(record.ReiId)}
              />
            </Tooltip1>

            <Tooltip1 title="Xem bảng kê">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<EyeOutlined />}
              />
            </Tooltip1>

            {record.ReiEStatus !== 4 && record.ReiSource !== 3 && (
              <Tooltip1 title="Đồng bộ hoá đơn điện tử">
                <Button1
                  type="text"
                  shape="circle"
                  size="small"
                  color="primary"
                  variant="text"
                  icon={<CloudUploadOutlined />}
                  onClick={() =>
                    handleSyncInvoice(
                      record.ReiId,
                      record.ReiEStatus,
                      record.ReiSource,
                    )
                  }
                />
              </Tooltip1>
            )}

            <Tooltip1 title="Xem lịch sử">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<HistoryOutlined />}
                onClick={() => {
                  setOpenInvoiceHistoryModal(true);
                  setCurrentRow(record);
                }}
              />
            </Tooltip1>

            <Tooltip1 title="Thêm">
              <Button1
                type="text"
                shape="circle"
                size="small"
                color="primary"
                variant="text"
                icon={<MoreOutlined />}
                onClick={(e) => handleOpenRowMenu(e, record)}
              />
            </Tooltip1>
          </Space>
        ),
      },
    ];
  }, [summary]);
  // --- 2. QUAN LÝ STATE ẨN HIỆN CỘT ---
  // Mặc định ban đầu sẽ hiển thị tất cả các cột
  const [visibleColumns, setVisibleColumns] = useState(
    allColumns.map((col) => col.key),
  );
  const [columnPopoverOpen, setColumnPopoverOpen] = useState(false);

  // Lọc ra các cột được phép tích chọn ẩn/hiện (bỏ qua cột 'actions')
  const filterableColumns = allColumns.filter((col) => col.label);

  // Giao diện Menu ẩn hiện cột nằm trong Popover
  const columnToggleMenu = (
    <div
      style={{
        maxHeight: "300px",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Checkbox.Group
        value={visibleColumns}
        onChange={(checkedValues) => setVisibleColumns(checkedValues)}
        style={{ display: "flex", flexDirection: "column", gap: "6px" }}
      >
        {filterableColumns.map((col) => (
          <Checkbox key={col.key} value={col.key}>
            {col.label}
          </Checkbox>
        ))}
      </Checkbox.Group>
    </div>
  );

  // Tính toán mảng cột thực tế truyền vào Table dựa trên State
  const displayedColumns = useMemo(() => {
    return allColumns
      .filter((col) => !col.label || visibleColumns.includes(col.key))
      .map((col) => {
        if (col.key === "actions") {
          return {
            ...col,
            title: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                }}
              >
                <span>Chức năng</span>
                <div onClick={(e) => e.stopPropagation()}>
                  <Popover
                    content={
                      <div onClick={(e) => e.stopPropagation()}>
                        {columnToggleMenu}
                      </div>
                    }
                    title="Cấu hình ẩn/hiện cột"
                    trigger="click"
                    placement="bottomRight"
                    getPopupContainer={() => document.body}
                    destroyTooltipOnHide={false}
                  >
                    <Tooltip1 title="Ẩn/Hiện cột">
                      <Button1
                        type="primary"
                        icon={<SettingOutlined />}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </Tooltip1>
                  </Popover>
                </div>
              </div>
            ),
          };
        }
        return col;
      });
  }, [visibleColumns, allColumns, columnToggleMenu, columnPopoverOpen]);

  const rowSelection = {
    selectedRowKeys: rowSelectionModel,
    onChange: (newSelectedRowKeys) => {
      setRowSelectionModel(newSelectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      // Chặn checkbox (disable) nếu ReiEStatus === 4 (Giống isRowSelectable của MUI)
      disabled: record.ReiEStatus === 4,
    }),
  };

  // --- 3. ĐỔI MÀU DÒNG (ROW CLASS NAME) ---
  const getRowClassName = (record) => {
    // Trả về class name tương ứng với trạng thái để css màu sắc
    if (record.ReiEStatus === 4) return "antd-row-sign";
    return "antd-row-default";
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <Box
        sx={{
          p: 1,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 64px)",
        }}
      >
        {/* Khung tìm kiếm */}
        <Paper elevation={3} sx={{ p: 2, mb: 2, display: "flex" }}>
          {/* <Grid
            container
            spacing={1}
            alignItems="center"
            sx={{
              width: 220,
              display: "flex",
              flexDirection: "row",
              paddingRight: 2,
            }}
          >
            <Grid sx={{}}>
              <Typography>Số HĐ nháp:</Typography>
              <Typography>Đồng bộ chưa ký:</Typography>
              <Typography>Đã ký phát hành:</Typography>
              <Typography>HĐ còn lại:</Typography>
            </Grid>
            <Grid sx={{ textAlign: "right" }}>
              <Typography>{totalInvoiceTmp || 0}</Typography>
              <Typography>{totalInvoiceSync || 0}</Typography>
              <Typography>{totalInvoiceSign || 0}</Typography>
              <Typography>{totalInvoiceRemain || 0}</Typography>
            </Grid>
          </Grid> */}
          <Grid container spacing={1} alignItems="center" sx={{ flex: 1 }}>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Ký hiệu hoá đơn"
                fullWidth
                value={searchQuery.invoiceTemplateId ?? -1}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    invoiceTemplateId:
                      e.target.value === -1 ? null : e.target.value,
                  }))
                }
                size="small"
              >
                {invoiceTemplate.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Trạng thái hoá đơn"
                fullWidth
                value={searchQuery?.invoiceStatus ?? -1}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    invoiceStatus:
                      e.target.value === -1 ? null : e.target.value,
                  }))
                }
                size="small"
                SelectProps={{
                  // 1. Cho ô hiển thị khi đã chọn cũng tự xuống dòng nếu cần
                  sx: {
                    "& .MuiSelect-select": {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                  // 2. Ép Menu thả xuống bằng đúng độ rộng ô TextField và tự ngắt dòng
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxWidth: "var(--select-width, 300px)", // Đề phòng
                        "& .MuiMenuItem-root": {
                          whiteSpace: "normal", // Cho phép xuống dòng
                          wordBreak: "break-word", // Ngắt từ nếu từ dài
                        },
                      },
                    },
                    // Giúp menu thả xuống khớp chính xác với độ rộng của ô TextField
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    // Khóa độ rộng Menu = độ rộng TextField
                    slotProps: {
                      paper: {
                        style: {
                          width: "auto", // Hoặc bỏ dòng này nếu dùng max-width ở trên
                        },
                      },
                    },
                  },
                }}
              >
                {invoiceStatus.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                select
                label="Hình thức thanh toán"
                fullWidth
                value={searchQuery?.paymentMethod ?? "-1"}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    paymentMethod: e.target.value,
                  }))
                }
                size="small"
              >
                {paymentMethods.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <DatePicker
                label="Từ ngày"
                format="DD/MM/YYYY"
                value={searchQuery.fromDate}
                onChange={(newValue) =>
                  setSearchQuery((prev) => ({ ...prev, fromDate: newValue }))
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <DatePicker
                label="Đến ngày"
                format="DD/MM/YYYY"
                value={searchQuery.toDate}
                onChange={(newValue) =>
                  setSearchQuery((prev) => ({ ...prev, toDate: newValue }))
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <Tooltip
                title="Bạn có thể nhập Số hoá đơn, Mã số thuế, Tên người mua, Mã CQT, Mã bill"
                arrow
              >
                <TextField
                  label="Từ khoá (Số HĐ, MST, Người mua, Mã CQT, Mã bill)"
                  fullWidth
                  value={searchQuery.searchKeyword}
                  onChange={(e) =>
                    setSearchQuery((prev) => ({
                      ...prev,
                      searchKeyword: e.target.value,
                    }))
                  }
                  size="small"
                />
              </Tooltip>
            </Grid>

            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                label="Tổng tiền lớn hơn"
                type="number"
                fullWidth
                value={searchQuery.fromAmount ?? ""}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    fromAmount: e.target.value,
                  }))
                }
                size="small"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 2.4 }}>
              <TextField
                label="Tổng tiền nhỏ hơn"
                type="number"
                fullWidth
                value={searchQuery.toAmount ?? ""}
                onChange={(e) =>
                  setSearchQuery((prev) => ({
                    ...prev,
                    toAmount: e.target.value,
                  }))
                }
                size="small"
              />
            </Grid>
            <Grid>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => {
                  setPaginationModel({
                    page: 1,
                    pageSize: paginationModel.pageSize,
                  });
                  SearchInvoices(searchQuery, {
                    page: 1,
                    pageSize: paginationModel.pageSize,
                  });
                }}
                size="large"
              >
                Tìm kiếm
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Box
          sx={{ mb: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}
        >
          {/* <Button onClick={() => setOpenBackdrop(true)}>Show backdrop</Button> */}
          <Button
            variant="contained"
            color="error"
            onClick={() => handleRemoveInvoice(0)}
          >
            Xoá phiếu nháp
          </Button>
          <Button
            variant="contained"
            color="info"
            title="Khách lẻ"
            onClick={() => btnGuest_Click()}
          >
            Khách lẻ
          </Button>
          <Button
            variant="contained"
            color="primary"
            title="Lấy trạng thái phát hành"
            onClick={() => handleGetInvoicesInfor()}
          >
            Lấy trạng thái phát hành
          </Button>
          <Button
            variant="contained"
            color="primary"
            title="Đồng bộ nhiều phiếu"
            onClick={() => handleSyncInvoices(0)}
          >
            Đồng bộ nhiều phiếu
          </Button>
          {invoiceConfig?.EsIsUseButtonSign &&
            invoiceConfig?.IcSignAllInvoice && (
              <Button
                variant="contained"
                color="primary"
                title="Ký phát hành"
                onClick={() => handleSignInvoice()}
              >
                Ký phát hành
              </Button>
            )}
          <Button
            variant="contained"
            color="success"
            title="Xuất Excel"
            onClick={() => handleExportExcel()}
          >
            Xuất Excel
          </Button>
        </Box>
        <div className="table-container" style={{ width: "100%" }}>
          <Table
            size="small"
            columns={displayedColumns}
            dataSource={invoices}
            loading={loadingHoaDon}
            rowKey="ReiId"
            rowSelection={rowSelection}
            rowClassName={getRowClassName}
            bordered // Hiển thị đường viền dọc giống showCellVerticalBorder của MUI
            // --- 4. KHẮC PHỤC TRÀN MÀN HÌNH & CỐ ĐỊNH HEADER ---
            scroll={{
              x: "max-content",
              // Thay '505px' bằng tổng chiều cao của Navbar + Toolbar + Khoảng cách lề của bạn
              // '100vh' là toàn bộ chiều cao màn hình, trừ đi phần trên thì table vừa khít không bị tràn.
              y: "calc(100vh - 405px)",
            }}
            // --- 5. ĐỒNG BỘ PHÂN TRANG (PAGINATION) ---
            pagination={{
              current: paginationModel.page, // Antd dùng base 1, MUI dùng base 0
              pageSize: paginationModel.pageSize,
              total: totalRowCount,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100", "200", "500", "1000"],
              onChange: (page, pageSize) => {
                setPaginationModel({ page: page, pageSize });
                SearchInvoices(searchQuery, { page: page, pageSize });
              },
              showTotal: (total) => {
                const selectedCount = rowSelectionModel?.length || 0;
                return (
                  <div className="pagination-wrapper-layout">
                    {/* Cụm 1: Hiển thị số dòng đã chọn (Nằm bên trái nhờ CSS) */}
                    <div className="selected-status-box">
                      {selectedCount > 0 && (
                        <span
                          style={{
                            backgroundColor: "#e6f7ff",
                            color: "#1890ff",
                            padding: "4px 12px",
                            borderRadius: "4px",
                            fontSize: "13px",
                            fontWeight: 500,
                            display: "inline-block",
                          }}
                        >
                          Đã chọn <strong>{selectedCount}</strong> dòng
                        </span>
                      )}
                    </div>

                    {/* Cụm 2: Hiển thị tổng số kết quả (Nằm bên phải) */}
                    <div className="total-result-text">
                      Tổng số <strong>{total}</strong> kết quả trong{" "}
                      <strong>
                        {Math.ceil(total / paginationModel.pageSize)}
                      </strong>{" "}
                      trang
                    </div>
                  </div>
                );
              },
              locale: { items_per_page: "/ trang" },
            }}
            // Nhúng Css chỉnh màu trực tiếp vào thẻ Table style
            styles={{
              body: {
                fontSize: "14px",
              },
            }}
            className="custom-antd-table"
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Không có dữ liệu"
                />
              ),
            }}
          />

          {/* CSS bổ sung để custom màu chữ các dòng và căn chỉnh đường viền đổ bóng */}
          <style>{`
  /* --- 1. CSS CHỈNH MÀU SẮC DÒNG VÀ ĐƯỜNG VIỀN KHÓA CỘT --- */
  .custom-antd-table .antd-row-default td { color: #bb5d00ff !important; }
  .custom-antd-table .antd-row-sign td { color: #0a0404ff !important; }
  .custom-antd-table .ant-table-cell-fix-right { background-color: #ffffff !important; box-shadow: -4px 0 8px -2px rgba(0,0,0,0.1) !important; }
  .custom-antd-table .ant-table-thead > tr > th 
  { height: 70px; 
    padding: 4px !important; 
    font-weight: bold !important; /* hoặc 600 nếu muốn đậm vừa */
    color: #000000 !important;   /* Đảm bảo màu chữ đen rõ nét */ 
  }
  
  /* --- 2. CSS ÉP CHIỀU CAO LẤP ĐẦY KHI TRỐNG DỮ LIỆU --- */
  .custom-antd-table .ant-table-placeholder { height: calc(100vh - 430px) !important; }
  .custom-antd-table .ant-table-placeholder .ant-table-expanded-row-fixed { height: 100%; display: flex; align-items: center; justify-content: center; }
  /* Cố định chiều cao thân bảng: Dù có 1 dòng hay nhiều dòng, bảng luôn giữ nguyên chiều cao chuẩn */
  .custom-antd-table .ant-table-body {
    min-height: calc(100vh - 420px) !important;
    height: calc(100vh - 420px) !important;
  }
  /* Giảm padding trên/dưới từ 8px xuống còn 3px hoặc 4px */
  .custom-antd-table .ant-table-tbody > tr > td {
    padding: 3px 8px !important;
  }

  /* --- 3. FIX SỰ CỐ BỊ ĐẨY XUỐNG DÒNG (ĐỒNG PHẲNG PAGINATION & SELECTION) --- */
  
  /* Cấu trúc lại toàn bộ hàng phân trang thành 1 dòng Flexbox duy nhất */
  .custom-antd-table .ant-pagination {
    display: flex !important;
    flex-flow: row nowrap !important; /* Khóa chết, tuyệt đối không cho phép xuống dòng */
    justify-content: flex-end !important;
    align-items: center !important;
    margin-top: 16px !important;
    width: 100% !important;
  }

  /* Ép thẻ li chứa chữ tổng số của Antd chiếm toàn bộ không gian trống còn lại */
  .custom-antd-table .ant-pagination-total-text {
    flex-grow: 1 !important;
    margin-right: 0 !important;
    padding-right: 16px;
        height: 32px !important;

  }

  /* Kích hoạt Flexbox cho layout bên trong showTotal */
  .pagination-wrapper-layout {
    display: flex !important;
    justify-content: space-between !important; /* Đẩy Đã chọn sang trái kịch kim, Tổng số sang phải kịch kim */
    align-items: center !important;
    width: 100% !important;
  }

  /* Hộp chứa số lượng dòng được chọn (Bên trái) */
  .pagination-wrapper-layout .selected-status-box {
    flex-shrink: 0;
  }

  /* Đoạn chữ tổng số kết quả (Bên phải - đứng ngay sát cạnh nút bấm trang) */
  .pagination-wrapper-layout .total-result-text {
    margin-left: auto !important; /* Tự động tính toán khoảng trống để đẩy sát sang phải */
    white-space: nowrap !important; /* Không cho chữ tổng số tự bẻ dòng */
  }

  /* Đảm bảo các nút bấm phân trang không bị bóp méo diện tích */
  .custom-antd-table .ant-pagination-item,
  .custom-antd-table .ant-pagination-prev,
  .custom-antd-table .ant-pagination-next,
  .custom-antd-table .ant-pagination-options {
    flex-shrink: 0 !important;
  }
`}</style>
        </div>

        <InvoiceModal
          open={isInvoiceModalOpen}
          onClose={handleCloseInvoiceModal}
          initialData={editingInvoiceData}
        />
        <InvoiceHistoryModal
          open={openInvoiceHistoryModal}
          onClose={() => setOpenInvoiceHistoryModal(false)}
          reiId={currentRow?.ReiId}
        />
        <InformationDialog
          open={informationDialogState.open}
          title={informationDialogState.title}
          content={informationDialogState.content}
          onConfirm={informationDialogState.onConfirm}
          confirmText={informationDialogState.confirmText}
        />
      </Box>
      <Menu
        anchorEl={anchorElRow}
        open={Boolean(anchorElRow)}
        onClose={handleCloseRowMenu}
      >
        <MenuItem onClick={handleClickAdjustInfo}>
          Điều chỉnh thông tin
        </MenuItem>
        <MenuItem onClick={handleClickAdjustIncrease}>Điều chỉnh tăng</MenuItem>
        <MenuItem onClick={handleClickAdjustDecrease}>Điều chỉnh giảm</MenuItem>
        <MenuItem onClick={handleClickReplaceInvoice}>Thay thế</MenuItem>
        <MenuItem>Giải trình</MenuItem>
        <MenuItem onClick={handleClickGetLinkUpdateInvoice}>
          Lấy link cập nhật HĐ
        </MenuItem>
      </Menu>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ConfirmDialog
        open={confirmDialogState.open}
        title={confirmDialogState.title}
        content={confirmDialogState.content}
        onConfirm={confirmDialogState.onConfirm}
        onClose={confirmDialogState.onClose}
      />
      <Dialog open={openGuestModal} size="sm" fullWidth>
        <DialogTitle>Cập nhật tên người mua cho phiếu khách lẻ</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Tên người mua"
            fullWidth
            size="small"
            value={guestNameExport}
            onChange={(e) => setGuestNameExport(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleCloseGuestModal}>
            Đóng
          </Button>
          <Button variant="contained" onClick={handleExportInvoiceGuest}>
            Xác nhận
          </Button>
        </DialogActions>
      </Dialog>
      <Spin
        spinning={isExporting}
        tip="Đang kết xuất dữ liệu hệ thống..."
        fullscreen
      ></Spin>
      <Spin
        spinning={isSystemProcessing}
        tip="Hệ thống đang xử lý dữ liệu..."
        fullscreen
      ></Spin>
    </LocalizationProvider>
  );
}

export default InvoicePage;
